<template>
  <div id="appf">
    <v-card
    class="progress-container"
    v-if="loading">
      <v-progress-circular
              :size="120"
              color="primary"
              indeterminate
      ></v-progress-circular>
    </v-card>

    <v-app v-else id="inspire">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">{{ $t('cyclic.create.assign_teams')}}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2">{{ $t('cyclic.create.assign_schemas')}}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <AssignTeams v-on:team-assigned="teamAssigned" v-bind:idCyclic="idCyclic" :cyclicTeams="cyclic.teams" ></AssignTeams>
          </v-stepper-content>

          <v-stepper-content step="2">
              <AssignSchemas v-on:schema-assigned="schemaAssigned" v-bind:idCyclic="idCyclic" :cyclicSchemas="cyclic.schemas" > </AssignSchemas>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-app>
  </div>
</template>

<script>
import http from '@/plugins/http'
import AssignTeams from './AssignTeams.vue'
import AssignSchemas from './AssignSchemas.vue'

export default {
  components: {
    AssignTeams,
    AssignSchemas
  },
  data() {
    return {
      basicValid: false,
      stepper: 1,
      idCyclic:0,
      loading: false,
      bottomNav: 3,
       e1: 1,
      cyclic:{"teams":[],"schemas":[]},
    }
  },
  computed: {

  },
  methods: {
    teamAssigned (){
        this.e1=2;

        this.$store.commit("setSnack", {
          message: this.$t("cyclic.create.teams_assigned", { username: this.username }) ,
          color: "success"
        })

    },
    schemaAssigned (){
        this.$store.commit("setSnack", {
          message: this.$t("cyclic.create.schemas_assigned", { username: this.username }) ,
          color: "success"
        })
          this.$router.push({ path: '/cyclic/view/'+this.idCyclic })
    },
    loadCyclic(){
      this.loading = true
      http.get('cyclic/'+ this.idCyclic)
              .then(response => {
                this.cyclic = response.data
                this.loading = false
              }).catch(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.idCyclic=this.$route.params.cyclicId
    this.loadCyclic();
  }
}
</script>

<style>

</style>
